import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCtIfuayklzzLm82odDLlEFNEwRCXgnyEI",
  authDomain: "shopsiteclone.firebaseapp.com",
  projectId: "shopsiteclone",
  storageBucket: "shopsiteclone.appspot.com",
  messagingSenderId: "632016685846",
  appId: "1:632016685846:web:32d01371ddcf8d2b099e37",
  measurementId: "G-E3SVFY390J"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();


export {db, auth};